import React from 'react';
import {useIntl} from 'react-intl'
import {SmallIndicatorCard} from '@/components/cards/IndicatorCard'
import {GlobalKpiModel} from '../../core/_models';

interface Props {
  data: GlobalKpiModel,
  isLoading: boolean
}

export const GlobalKpi: React.FC<Props> = ({ data, isLoading }) => {
  const intl = useIntl()

  const moneyFormat = (value: number) =>
    intl.formatNumber(value, { style: 'currency', currency: 'EUR' });

  const df = (date: Date) => 
    intl.formatDate(date, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: false
    });

  return (
    <div className="row">
      <div className="col-xl-6">
        <SmallIndicatorCard
          title="Stock"
          padding="p-4"
          icon="delivery-3"
          color="danger"
          isLoading={isLoading}
          value={
            <>
              <div className="d-flex justify-content-between align-items-center">
                <div className="me-8" title="Vouchers">
                  {intl.formatNumber(data.stock.vouchers)}
                </div>
                <div className="text-end" title="COGS">
                  <div>{moneyFormat(data.stock.amount)}</div>
                  <div className="text-end text-white-50 fst-italic" title="Retail value">
                    {moneyFormat(data.stock.value)}
                  </div>
                </div>
              </div>
            </>
          }
        />
      </div>
      <div className="col-xl-6">
        <SmallIndicatorCard
          title="Pending support"
          padding="p-4"
          icon="message-question"
          color="info"
          isLoading={isLoading}
          value={
            <>
              <div className="text-end">
                {intl.formatNumber(data.supportTickets)}
              </div>
              <div className="text-end text-white-50 fst-italic">
                Pending tickets
              </div>
            </>
          }
        />
      </div>
      <div className="col-xl-6">
        <SmallIndicatorCard
          title="Last payment"
          padding="p-4"
          icon="two-credit-cart"
          color="success"
          isLoading={isLoading}
          value={
            <>
              <div className="text-end">
                {df(data.lastPayment.date)}
              </div>
              <div className="text-end text-white-50 fst-italic">
                <span className='me-2'>
                  {intl.formatMessage({id: `P2C.PAYMODE_${data.lastPayment.type.toUpperCase()}`})}
                </span>
                {moneyFormat(data.lastPayment.amount)}
              </div>
            </>
          }
        />
      </div>
      <div className="col-xl-6">
        <SmallIndicatorCard
          title="Last order"
          padding="p-4"
          icon="handcart"
          color="primary"
          isLoading={isLoading}
          value={
            <>
              <div className="text-end">
                {df(data.lastOrder.date)}
              </div>
              <div className="text-end text-white-50 fst-italic fs-2" title={data.lastOrder.product}>
                {data.lastOrder.product.length > 20
                  ? data.lastOrder.product.slice(0, 20) + "..."
                  : data.lastOrder.product
                }
              </div>
            </>
          }
        />

      </div>
    </div>
  );
}
